import {
  MEMBER_CONVERSION_TYPES,
  ONBOARD_CONVERSION_TYPES,
  ORIGIN_TYPES,
  USER_TYPES,
} from '../constants/common';

export const getMemberConversionType = ({
  billerNotified,
  onboardType,
  showAPForcedConverted,
}: {
  billerNotified?: boolean;
  onboardType?: string;
  showAPForcedConverted: boolean;
}) => {
  let conversionType = undefined;
  let showForcedConversionModal = false;
  if (onboardType === ONBOARD_CONVERSION_TYPES.FORCED_CONVERSION) {
    conversionType = MEMBER_CONVERSION_TYPES.FORCED_CONVERSION_WITHOUT_AUTOPAY;
    showForcedConversionModal = true;
  }
  if (
    onboardType === ONBOARD_CONVERSION_TYPES.CONVERSION &&
    billerNotified === false
  ) {
    conversionType = MEMBER_CONVERSION_TYPES.FORCED_CONVERSION_WITH_AUTOPAY;
    showForcedConversionModal = true;
  }
  if (showAPForcedConverted) {
    conversionType = MEMBER_CONVERSION_TYPES.AP_FORCED_CONVERSION;
    showForcedConversionModal = true;
  }

  return {
    conversionType,
    showForcedConversionModal,
  };
};

export const getGovtUserType = (
  ORIGIN?: string,
  isLoginNavigation?: boolean,
) => {
  // This should be called for government members only
  if (ORIGIN === ORIGIN_TYPES.CA) {
    return USER_TYPES.CA_GOVT_USER;
  }
  if (ORIGIN === ORIGIN_TYPES.NMA || ORIGIN === ORIGIN_TYPES.UMA) {
    return USER_TYPES.NMA_GOVT_USER;
  }
  if (isLoginNavigation && ORIGIN === ORIGIN_TYPES.BAM) {
    return USER_TYPES.BAM_GOVERNMENT_ACTIVE_MEMBER;
  }
  if (!isLoginNavigation && ORIGIN === ORIGIN_TYPES.BAM_GOVERNMENT_ACTIVE) {
    return USER_TYPES.BAM_GOVERNMENT_ACTIVE_MEMBER;
  }
  return USER_TYPES.ONE_TIME_GOVERNMENT_ACTIVE_MEMBER;
};

export const getGovtOrigin = (ORIGIN?: string) => {
  // This should be called for government members only
  if (ORIGIN === ORIGIN_TYPES.CA) {
    return ORIGIN_TYPES.CA;
  }
  if (ORIGIN === ORIGIN_TYPES.NMA) {
    return ORIGIN_TYPES.NMA;
  }
  if (ORIGIN === ORIGIN_TYPES.UMA) {
    return ORIGIN_TYPES.UMA;
  }
  if (ORIGIN === ORIGIN_TYPES.BAM) {
    return ORIGIN_TYPES.BAM_GOVERNMENT_ACTIVE;
  }
  return ORIGIN_TYPES.ONE_TIME_GOVERNMENT_ACTIVE;
};
